import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class reportGraphql extends GraphQlService {
  async getReportAttributes(accountId) {
    return this.client
      .query({
        query: gql`
                query{
                  getReportAttributes(id:"${accountId}"){
                    attributeName
                    attributeValue
                  }
                }
                `,
      })
      .then((result) => result?.data?.getReportAttributes ?? []);
  }

  async getAllReportsAndNotesByCustomRoleId(
    startDate,
    endDate,
    userId = null,
    journalTypeId = null,
  ) {
    return this.client
      .mutate({
        mutation: gql`
                mutation{
                  getAllReportsAndNotesByCustomRoleId(
                    getReportAndNotesInput:{
                      startDate:"${startDate}",
                      endDate:"${endDate}",
                      userId: ${userId ? `"${userId}"` : null},
                      journalTypeId: ${journalTypeId ? `"${journalTypeId}"` : null}
                    }){
                    reports {
                      id
                      accountId
                      userId
                      reporterId
                      data
                      createdAt
                      updatedAt
                      createdBy
                      updatedBy
                      version
                      type
                      isPublic
                      createdByUser {
                        accountPeople {
                          accountId
                          userId
                          name
                        }
                      }
                          journalType{
                        id
                        nameEng
                        nameSw
                        public
                      }
                      user {
                        accountPeople{
                          name
                          anonymousName
                          isAnonymous
                          accountPersonAttributes{
                            id
                            name
                            value
                          }
                        }
                      }
                    }
                    notes {
                      id
                      note
                      type
                      creatorName
                      createdAt
                      createdBy
                      updatedAt
                      updatedBy
                      pinned
                      isPublic
                       journalType{
                        id
                        nameEng
                        nameSw
                        public
                      }
                      user{
                        accountPeople{
                          name
                          isAnonymous
                          anonymousName
                          accountPersonAttributes{
                            id
                            name
                            value
                          }
                        }
                      }
                    }
                    customReports{
                          id
                          userId
                          accountId
                          content
                          reportConfigId
                          status
                          signatureStatus
                          signedAt
                          template
                          createdAt
                          updatedAt
                          createdBy
                          updatedBy
                           journalType{
                        id
                        nameEng
                        nameSw
                        public
                      }
                          reportConfig{
                                id
                                reportTemplate
                                            {
                                              id
                                            name
                                            }
                                          }
                          qa {
                             question
                             answer
                             image
                            }
                          createdByUser {
                            accountPeople {
                                userId
                                accountId
                                name
                            }
                          }
                          user {
                            accountPeople {
                                name
                                anonymousName
                                isAnonymous
                                 accountPersonAttributes {
                                              id
                                              name
                                              value
                                              __typename
                                            }
                                    __typename
                                  }
                        __typename
                        }
                      }
                    responseDate
                    dataOver
                  }
                }
                `,
      })
      .then((result) => result?.data?.getAllReportsAndNotesByCustomRoleId);
  }

  async getReportByIdAndAccountId(id, accountId) {
    return this.client
      .query({
        query: gql`
                query{
                  getReportByIdAndAccountId(getReportByIdInput:{
                    id:"${id}",
                    accountId:"${accountId}",
                  }){
                    id
                    accountId
                    userId
                    reporterId
                    entityId
                    data
                    createdAt
                    updatedAt
                    createdBy
                    updatedBy
                    version
                    type
                    isPublic
                    createdByUser {
                      accountPeople {
                        accountId
                        userId
                        name
                      }
                    }
                    user {
                      accountPeople{
                        name
                        anonymousName
                        isAnonymous
                        accountPersonAttributes{
                          id
                          name
                          value
                        }
                      }
                    }
                  }
                }
                `,
      })
      .then((result) => result?.data?.getReportByIdAndAccountId);
  }

  async getCustomReportDataByIdAndAccountId(id, accountId) {
    return this.client
      .query({
        query: gql`
        query {
          getCustomReportDataByIdAndAccountId(
            getCustomReportByIdInput: {
              id: "${id}",
              accountId: "${accountId}"
            }
          ) {
            id
            userId
            accountId
            content
            reportConfigId
            anonymousData
            reportConfig {
              id
              reportTemplateId
              allowAnonymousReports
              reportTemplate {
                id
                name
                screenType
                content
              }
            }
            customReportTaggedUsers {
              id
              accountPeople {
                id
                accountId
                name
                profilePictureName
              }
            }
            status
            signatureStatus
            signedBy
            signedAt
            unlockedBy
            unlockedAt
            unlockReason
            allowGuestEditing
            template
            createdAt
            createdBy
            qa {
              question
              answer
              image
              answerFile
            }
            createdByUser {
              accountPeople {
                userId
                accountId
                name
                id
              }
            }
            user {
              accountPeople {
                name
                isAnonymous
                id
                accountId
              }
            }
            account {
              profilePictureName
            }
          }
        }
      `,
      })
      .then((result) => result?.data?.getCustomReportDataByIdAndAccountId);
  }

  async removeReportById(id) {
    return this.client
      .mutate({
        mutation: gql`
                mutation{
                  removeReportById(id: "${id}") {
                    response {
                      messages {
                        message
                      }
                    }
                  }
                }
                `,
      })
      .then((result) => result?.data?.removeReportById);
  }

  async removeCustomReportById(id) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            removeCustomReportById(id: "${id}") {
              response {
                messages {
                  message
                }
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.removeCustomReportById);
  }

  async getAllReportTopicsCategory(reportType) {
    return this.client
      .query({
        query: gql`
          {
            getAllReportTopicsCategory(
              getReportTopicsCategoryInput: { reportType: "${reportType}" }
            ) {
              id
              nameENG
              nameSW
              value
              reportTopics {
                id
                accountId
                nameENG
                nameSW
                value
                descriptionENG
                descriptionSW
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.getAllReportTopicsCategory);
  }

  async createReportTopics(data) {
    return this.client
      .mutate({
        mutation: gql`
          mutation {
            createReportTopics(
              createReportTopicsInput: {
                nameENG: "${data.name}"
                nameSW: "${data.name}"
                value: "${data.value}"
                descriptionENG: "${data.description}"
                descriptionSW: "${data.description}"
                accountId: "${data.accountId}"
                categoryId: "${data.categoryId}"
              }
            ) {
              id
            }
          }
          `,
      })
      .then((result) => result?.data?.createReportTopics);
  }

  async getReportTopicsByType(reportType) {
    return this.client
      .mutate({
        mutation: gql`
          mutation{
            getReportTopicsByType(
              getReportTopicsByTypeInput: { reportType: "${reportType}" }
            ) {
              id
              nameENG
              nameSW
              value
              descriptionENG
              descriptionSW
              accountId
              categoryId
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              category{
                value
              }
            }
          }
        `,
      })
      .then((result) => result?.data?.getReportTopicsByType);
  }

  async updateReport(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation{
          updateReport(
            updateReportInput:{
              id:"${data.id}",
              isPublic:${data.isPublic},
            }
          ){
            id
            accountId
            userId
            reporterId
            data
            createdAt
            updatedAt
            createdBy
            updatedBy
            version
            type
            isPublic
          }
        }
      `,
      })
      .then((result) => result?.data?.updateReport);
  }

  async createReportForLeyr(reportPayload) {
    return this.client
      .mutate({
        mutation: gql`
          mutation createReportForLeyr($data: String!) {
            createReportForLeyr(createLeyrReportInput: { data: $data })
          }
        `,
        variables: {
          data: JSON.stringify(reportPayload),
        },
      })
      .then((result) => result?.data?.createReportForLeyr);
  }

  async createNoteForLeyr(notePayload) {
    return this.client
      .mutate({
        mutation: gql`
          mutation createNoteForLeyr($data: String!) {
            createNoteForLeyr(createLeyrReportInput: { data: $data })
          }
        `,
        variables: {
          data: JSON.stringify(notePayload),
        },
      })
      .then((result) => result?.data?.createNoteForLeyr);
  }

  async getReportDocumentsByProfileId(
    profileId,
    accountId = null,
    journalTypeId = null,
  ) {
    return this.client
      .query({
        query: gql`
          query {
            getReportDocumentsByProfileId(
                profileId: "${profileId}",
                accountId: "${accountId}",
                journalTypeId: "${journalTypeId}"
            ) {
              id 
              accountId
              journalTypeId
              entityId
              entityType
              resourceName
              resourceType
              contentType
              size
              description
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              createdByUser{
                    id
                    accountPeople {
                      id
                      accountId
                      name
                    }
                }
            }
          }
        `,
      })
      .then((result) => result?.data?.getReportDocumentsByProfileId);
  }

  async getTopicsChartStatistics(dtStart, dtEnd, pairs, filters, language) {
    return this.client
      .query({
        query: gql`
          query GetTopicsChartStatistics(
            $dtStart: Float!
            $dtEnd: Float!
            $pairs: [UserAccountPairInput!]
            $filters: [ProfileFilterInput!]
            $language: String
          ) {
            getTopicsChartStatistics(
              dtStart: $dtStart
              dtEnd: $dtEnd
              pairs: $pairs
              filters: $filters
              language: $language
            ) {
              reportsCount
              topics {
                name
                category
                categoryLabel
                count
                percentage
                colorHex
              }
              meetingTypes {
                name
                count
                percentage
                colorHex
              }
              additionalSupport {
                name
                count
                percentage
                colorHex
              }
            }
          }
        `,
        variables: {
          dtStart,
          dtEnd,
          pairs: pairs ?? null,
          filters: filters?.length
            ? filters.map((filter) => ({
                key: filter.key,
                isEqual: !!filter.isEqual,
                value: `${filter.value}`,
              }))
            : null,
          language,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getTopicsChartStatistics);
  }

  async getBucketedMeetingKindStatistics(
    dtStart,
    dtEnd,
    buckets,
    pairs,
    filters,
    language
  ) {
    return this.client
      .query({
        query: gql`
          query GetBucketedMeetingKindStatistics(
            $dtStart: Float!
            $dtEnd: Float!
            $buckets: [DateRangeBucketInput!]!
            $pairs: [UserAccountPairInput!]
            $filters: [ProfileFilterInput!]
            $language: String
          ) {
            getBucketedMeetingKindStatistics(
              dtStart: $dtStart
              dtEnd: $dtEnd
              buckets: $buckets
              pairs: $pairs
              filters: $filters
              language: $language
            ) {
              buckets {
                meetingKinds {
                  name
                  count
                }
              }
              summary {
                name
                count
                percentage
                colorHex
              }
              total
            }
          }
        `,
        variables: {
          dtStart,
          dtEnd,
          buckets,
          pairs: pairs ?? null,
          filters: filters?.length
            ? filters.map((filter) => ({
                key: filter.key,
                isEqual: !!filter.isEqual,
                value: `${filter.value}`,
              }))
            : null,
          language,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getBucketedMeetingKindStatistics);
  }

  async getWorryLevelChartStatistics(
    dtStart,
    dtEnd,
    buckets,
    pairs,
    filters,
    worriedValueWithoutZero
  ) {
    return this.client
      .query({
        query: gql`
          query GetWorryLevelChartStatistics(
            $dtStart: Float!
            $dtEnd: Float!
            $buckets: [DateRangeBucketInput!]!
            $pairs: [UserAccountPairInput!]
            $filters: [ProfileFilterInput!]
            $worriedValueWithoutZero: Boolean
          ) {
            getWorryLevelChartStatistics(
              dtStart: $dtStart
              dtEnd: $dtEnd
              buckets: $buckets
              pairs: $pairs
              filters: $filters
              worriedValueWithoutZero: $worriedValueWithoutZero
            ) {
              buckets {
                levelOfWorry
              }
              average
            }
          }
        `,
        variables: {
          dtStart,
          dtEnd,
          buckets,
          pairs: pairs ?? null,
          filters: filters?.length
            ? filters.map((filter) => ({
                key: filter.key,
                isEqual: !!filter.isEqual,
                value: `${filter.value}`,
              }))
            : null,
          worriedValueWithoutZero: !!worriedValueWithoutZero,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getWorryLevelChartStatistics);
  }

  async getProfileWorryLevelChartStatistics(
    dtStart,
    dtEnd,
    buckets,
    userId,
    customRolesId,
    worriedValueWithoutZero
  ) {
    return this.client
      .query({
        query: gql`
          query GetProfileWorryLevelChartStatistics(
            $dtStart: Float!
            $dtEnd: Float!
            $buckets: [DateRangeBucketInput!]!
            $userId: String!
            $customRolesId: String
            $worriedValueWithoutZero: Boolean
          ) {
            getProfileWorryLevelChartStatistics(
              dtStart: $dtStart
              dtEnd: $dtEnd
              buckets: $buckets
              userId: $userId
              customRolesId: $customRolesId
              worriedValueWithoutZero: $worriedValueWithoutZero
            ) {
              buckets {
                levelOfWorry
              }
              average
            }
          }
        `,
        variables: {
          dtStart,
          dtEnd,
          buckets,
          userId,
          customRolesId: customRolesId ?? null,
          worriedValueWithoutZero: !!worriedValueWithoutZero,
        },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getProfileWorryLevelChartStatistics);
  }

  async getInternalMeetingDurationByType(dtStart, dtEnd) {
    return this.client
      .query({
        query: gql`
          query GetInternalMeetingDurationByType(
            $dtStart: Float!
            $dtEnd: Float!
          ) {
            getInternalMeetingDurationByType(dtStart: $dtStart, dtEnd: $dtEnd) {
              entries {
                meetingType
                value
              }
              reportsCount
            }
          }
        `,
        variables: { dtStart, dtEnd },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getInternalMeetingDurationByType);
  }

  async getInternalMeetingDurationByAttribute(dtStart, dtEnd, attributeKey) {
    return this.client
      .query({
        query: gql`
          query GetInternalMeetingDurationByAttribute(
            $dtStart: Float!
            $dtEnd: Float!
            $attributeKey: String!
          ) {
            getInternalMeetingDurationByAttribute(
              dtStart: $dtStart
              dtEnd: $dtEnd
              attributeKey: $attributeKey
            ) {
              entries {
                attrValue
                count
              }
              totalHours
            }
          }
        `,
        variables: { dtStart, dtEnd, attributeKey },
        fetchPolicy: "no-cache",
      })
      .then((result) => result?.data?.getInternalMeetingDurationByAttribute);
  }
}
const reportGraphqlInstance = new reportGraphql();
export default reportGraphqlInstance;
